export const fmt = (n: number | string) =>
  new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(Number(n));

export const fmtMonth = (m: string) =>
  new Date(m + '-01').toLocaleDateString('en-US', { month: 'long', year: 'numeric' });

export const THIS_MONTH = new Date().toISOString().substring(0, 7);

const THIS_YEAR = new Date().getFullYear();
export const THIS_SESSION = `${THIS_YEAR}-${String(THIS_YEAR + 1).slice(2)}`;